export const PageTextCanceled = `Seja bem vindo de volta! Percebemos que você está há um tempo sem
utilizar a nossa plataforma, mas não se preocupe, os dados do seu
cardápio digital: produtos, pedidos, clientes, etc, ainda estão guardados
conosco.`;
export const PageTextCanceled1 = `Para que você volte a ter acesso a plataforma da Kuppi,
basta efetuar o pagamento e será iniciado um novo período de uso da
plataforma, conforme detalhado abaixo no campo "Vigência" dos Detalhes
do plano.`;
export const PageTextCanceled2 = `Ao efetuar o pagamento, você estará concordando com os nossos termos de uso, `;
